export enum View {
  LIST = 'list',
  MAP = 'map'
}

export enum FilterName {
  BRANCH = 'branch',
  ATM = 'atm',
  COOP = 'coop'
}

export type LocationItemLabelProps = {
  ariaLabelCloseBtn: string;
  labelMilesAway: string;
  labelGetDirectionsBtn: string;
  labelCallUsBtn: string;
  labelGetDirectionsModalTitle: string;
  labelGetDirectionsModalMessage: string;
  labelGetDirectionsModalProceedBtn: string;
  labelLearnMoreBtn: string;
};

export type LocationProps = {
  id: string;
  headline: string;
  name: string;
  phone: string;
  link: string;
  distance: string;
  serviceHeading: string;
  products: {
    Icon: string;
    Url: string;
    Text: string;
  }[];
  locatorType: string;
  address: {
    street: string;
    street2: string;
    city: string;
    state: string;
    zip: string;
    latitude: string;
    longitude: string;
  };
  services: string[];
  hourHeading: string;
  lobbyHoursHeading: string;
  driveThruHeading: string;
  videoTellerHeading: string;
  driveThruVideoTellerHeading: string;
  atmHeading: string;
  lobbyHours: {
    day: string;
    time: string;
  }[];
  driveThruHours: {
    day: string;
    time: string;
  }[];
  videoTellerHours: {
    day: string;
    time: string;
  }[];
  driveThruVideoTellerHours: {
    day: string;
    time: string;
  }[];
  atmHours: {
    day: string;
    time: string;
  }[];
  image: string;
};

export type LocationItemProps = LocationItemLabelProps & {
  locationId: string;
  type: `${FilterName}`;
  isActive: boolean;
  onClick: (locationId: string, scrollToLocation?: boolean, centerMap?: boolean) => void;
  locationData: LocationProps;
};

export type LocationListingProps = LocationItemLabelProps & {
  googleMapsApiKey: string;
  locationApiUrl: string;
  defaultLatitude: string;
  defaultLongitude: string;
  labelSearchInput: string;
  labelLocateBtn: string;
  labelSearchBtn: string;
  labelBranchCheckbox: string;
  labelAtmCheckbox: string;
  labelCoopCheckbox: string;
  labelListViewBtn: string;
  labelMapViewBtn: string;
  labelBackToTopBtn: string;
  filterPlaceholder: string;
  filterOptions: string;
  filterApplyLabel: string;
  filterResetLabel: string;
  locationIframeTitle: string;
  mapIframeTitle: string;
};
